<template lang="pug">
  .mt-3
    div {{ $t('components.login_bridge.tpl.authenticating') }}...
    div(v-if="loginDone") {{ $t('components.login_bridge.tpl.loading') }}...
</template>

<script>
import { mapActions } from 'vuex';
import { URLS } from '@/util';

export default {
  props: {
    instance: {
      type: String,
      default: null,
    },
    token: {
      type: Object,
      default: null,
    },
    username: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loginDone: false,
    };
  },
  async created() {
    try {
      await this.doLogin({
        token: this.token,
        username: this.username,
        instance: this.instance,
      });
      this.loginDone = true;
      setTimeout(() => {
        this.$router.push({
          name: 'projects',
          params: {
            instance: this.instance,
          },
        });
      }, 2000);
    } catch (e) {
      this.$message.error(
        this.$t('components.login_bridge.js.error_message'),
        3,
        () => { window.location = URLS.defaultRedirect; },
      );
    }
  },
  methods: {
    ...mapActions('login', [
      'doLogin',
    ]),
  },
};
</script>
